import React, { FC, useState } from "react";
import { Col, Input, Row } from "antd";

import { IModal } from "@types";
import Modal from "@components/Modal";
import { ErrorServices, useCreateSubJobFunctionMutation } from "@services";
import Button from "@/components/Button";

export interface IAddJobSubFunction extends IModal {
  job_function_id: string | number;
}

const AddJobSubFunction: FC<IAddJobSubFunction> = ({
  isVisible,
  setIsVisible,
  job_function_id,
}) => {
  const [jobFunction, setJobFunction] = useState("");
  const [createSubJobFunction, { isLoading }] =
    useCreateSubJobFunctionMutation();

  const onSubmit = async () => {
    try {
      await createSubJobFunction({
        name: jobFunction,
        job_function_id,
      }).unwrap();
      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setJobFunction(e.target.value);
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobFunction("");
  };
  return (
    <Modal
      width={544}
      onClose={closeModal}
      footer={[
        <Button
          key="1"
          variant="buttonCore"
          disabled={!jobFunction || isLoading}
          onClick={onSubmit}
          isLoading={isLoading}
          className="w-56"
        >
          Add
        </Button>,

        <Button
          key="2"
          variant="buttonBlue"
          onClick={closeModal}
          className="w-28"
        >
          Cancel
        </Button>,
      ]}
      title="Add a Job-Sub Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Job-Sub Function</label>
            <Input
              value={jobFunction}
              onChange={handleInput}
              size="large"
              placeholder="Name of the job-sub function here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default AddJobSubFunction;
